import React, { useState, useRef, useEffect } from 'react';
import ModelSelector from './ModelSelector';
import ModelEvaluator from './ModelEvaluator';
import VisualPromptEditor from './VisualPromptEditor';
import ThemeSelector from './ThemeSelector';
import '../styles/Sidebar.css';

function Sidebar({ 
  theme, 
  onThemeChange,
  collapsed, 
  toggleSidebar, 
  onNewChat, 
  onUploadDocument,
  isUploading,
  uploadProgress,
  onModelChange
}) {
  const [showModelEvaluator, setShowModelEvaluator] = useState(false);
  const [showPromptEditor, setShowPromptEditor] = useState(false);
  const [showThemeSelector, setShowThemeSelector] = useState(false);
  const themeSelectorRef = useRef(null);

  // Close theme selector when clicking outside of it
  useEffect(() => {
    function handleClickOutside(event) {
      if (themeSelectorRef.current && !themeSelectorRef.current.contains(event.target)) {
        setShowThemeSelector(false);
      }
    }

    if (showThemeSelector) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showThemeSelector]);

  return (
    <>
      <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <button className="hamburger-btn" onClick={toggleSidebar}>
              <span className="material-icons">menu</span>
            </button>
            {!collapsed && (
              <img 
                src={theme === 'light' ? "/HCLSoftware_black.png" : "/HCLSoftware_white.png"} 
                alt="Logo" 
                className="brand-logo" 
              />
            )}
          </div>
          
          {!collapsed && <ModelSelector onModelChange={onModelChange} />}
        </div>
        
        <div className="sidebar-new-chat">
          <button className="new-chat-btn" onClick={onNewChat}>
            <span className="material-icons">add</span>
            {!collapsed && "New chat"}
          </button>
        </div>
        
        <div className="sidebar-footer">
          {/* <button 
            className="sidebar-btn upload-doc-btn" 
            onClick={onUploadDocument}
            title="Upload Document"
          >
            {isUploading ? (
              <div className="sidebar-upload-progress">
                <div className="progress-bar" style={{width: `${uploadProgress}%`}}></div>
              </div>
            ) : (
              <span className="material-icons">upload_file</span>
            )}
            {!collapsed && <span>Upload Document</span>}
          </button>
           */}
          
          <button 
            className="sidebar-btn" 
            onClick={() => setShowPromptEditor(true)}
            title="Visual Prompt Editor"
          >
            <span className="material-icons">format_shapes</span>
            {!collapsed && <span>Prompt Editor</span>}
          </button>
          
          <button 
            className="sidebar-btn" 
            onClick={() => setShowModelEvaluator(true)}
            title="Evaluate Models"
          >
            <span className="material-icons">speed</span>
            {!collapsed && <span>Evaluate Models</span>}
          </button>
          
          <div className="theme-selector-container" ref={themeSelectorRef}>
            <button 
              className="sidebar-btn" 
              onClick={() => setShowThemeSelector(!showThemeSelector)}
              title="UI Themes"
            >
              <span className="material-icons">palette</span>
              {!collapsed && <span>UI Themes</span>}
            </button>
            
            {showThemeSelector && (
              <ThemeSelector 
                currentTheme={theme} 
                onThemeChange={(themeId) => {
                  onThemeChange(themeId);
                  setShowThemeSelector(false);
                }}
                onClose={() => setShowThemeSelector(false)} 
              />
            )}
          </div>
        </div>
      </div>

      {showModelEvaluator && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Model Evaluation & Recommendation</h2>
              <button 
                className="modal-close-btn" 
                onClick={() => setShowModelEvaluator(false)}
              >
                <span className="material-icons">close</span>
              </button>
            </div>
            <div className="modal-body">
              <ModelEvaluator />
            </div>
          </div>
        </div>
      )}

      {showPromptEditor && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Visual Prompt Editor</h2>
              <button 
                className="modal-close-btn" 
                onClick={() => setShowPromptEditor(false)}
              >
                <span className="material-icons">close</span>
              </button>
            </div>
            <div className="modal-body">
              <VisualPromptEditor />
            </div>
          </div>
        </div>
      )}
      
    </>
  );
}

export default Sidebar;